import * as React from 'react'
import * as Redux from 'react-redux'
import styled from 'styled-components'
import * as model from '@owl-nest/models'

import { t } from '@owl-nest/localize'
import { BREAKPOINTS, COLORS, styles as S } from '@ulule/owl-kit-components/next'
import { SocialSquare } from '../../components/SocialSquare'

import { Project } from '../../../../models/project'
import { RootState } from '../../../../../reducers'

import { DisplayMode } from '../../../../context'
import { EditButton } from '../../components/EditButton'
import * as projectModel from '../../../../models/project'

type SocialFollowProps = {}

const Content = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  margin-top: 18px;

  @media screen and ${BREAKPOINTS.TABLET} {
    display: grid;
    grid-template-columns: auto auto;
    grid-gap: 10px 30px;
  }
`

const EditButtonWrapper = styled.div`
  position: absolute;
  right: 10px;
  top: 10px;
`

const Item = styled.div`
  margin-bottom: 15px;

  @media screen and ${BREAKPOINTS.LAPTOP} {
    min-width: 220px;
  }
`

const Wrapper = styled.div`
  background-color: ${COLORS.PRIMARY_SAND};
  margin-bottom: 25px;
  padding: 26px 10px;
  position: relative;

  @media screen and ${BREAKPOINTS.LAPTOP} {
    margin-bottom: 50px;
    padding: 15px 26px;
    padding-bottom: 0px;

    ${S.heading.M} {
      margin-bottom: 25px;
    }
  }
`

export function SocialFollow(): React.ReactElement<SocialFollowProps> {
  const displayMode = React.useContext(DisplayMode)
  const project = Redux.useSelector<RootState, Project>((state) => state.application.project.data)
  const isEditMode = displayMode === 'edit'

  return (
    <Wrapper>
      <S.heading.M>{t('Follow the project on')}</S.heading.M>
      <Content>
        {project.links?.map((link) => (
          <Item key={link.id}>
            <SocialSquare platform={link.service_type} url={link.url}>
              {model.i18n.get(link.title)}
            </SocialSquare>
          </Item>
        ))}
      </Content>
      {isEditMode && !model.project.refused<projectModel.ExtraFields>(project) && (
        <EditButtonWrapper>
          <EditButton link={`/projects/${project.id}/edit/layout/?form-0-url`} />
        </EditButtonWrapper>
      )}
    </Wrapper>
  )
}
